module.exports = __webpack_public_path__ + "static/media/viposterLogo_darkBG_horizontal.853d7198.svg";